import React, { ReactNode } from 'react'
import { H1 } from '../StyledText'

interface ICombinedTitle {
  first: ReactNode
  second: ReactNode
  color?: string
  [key: string]: any
}

export const CombinedTitle = ({
  first,
  second,
  color, // FIXME: not used
  ...rest
}: ICombinedTitle) => (
  <H1 {...rest}>
    {first}{' '}
    <H1 inline={true} color="primary" component="span" {...rest}>
      {second}
    </H1>
  </H1>
)
